// App.jsx
import LampContainer from "../components/lampContainer";
import HeardContainer from "../components/heardContainer";

function Home () {
    document.title = '海马软件'
    const keyword = document.querySelector('meta[name="keyword"]')
    keyword.setAttribute('content', '海马软件、海马AI客服系统、海马聊天、海马IM、海马chat、海马智能监控、独立部署、私有化部署')
    const description = document.querySelector('meta[name="description"]')
    description.setAttribute('content', '我们用云原生与 AI 驱动企业软件，连接业务与智能决策。高可靠、低延时、易扩展，助力企业迈向下一代技术栈。')
    const contactUs = () => {
        window.open("https://t.me/haimakefu88", "_blank")
    }
    return (
        <div className="min-h-screen bg-gradient-radial from-[#7b61ff]/10 via-transparent to-[#070814] text-[#eaf5ff] font-sans">
            <div className="max-w-6xl mx-auto p-7">
                <HeardContainer tilte="海马软件" subtitle="智能 · 可靠 · 科技驱动"/>
                {/* Hero */}
                <section className="grid items-center">
                    <LampContainer>
                        <h1 className="text-base font-extrabold leading-tight sm:text-4xl">
                            未来·现在 — <span className="animate-gradient-text bg-gradient-to-r from-sky-400 via-pink-400 to-indigo-500 bg-clip-text text-transparent">海马软件</span>
                        </h1>
                        <p className="mt-4 text-sky-200/80 max-w-xl">我们用云原生与 AI 驱动企业软件，连接业务与智能决策。高可靠、低延时、易扩展，助力企业迈向下一代技术栈。</p>
                    </LampContainer>
                </section>

                {/* 特性区 */}
                <section className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {[
                        { title: '云原生架构', desc: '微服务与自动伸缩，支持混合部署' },
                        { title: 'AI 驱动洞察', desc: '模型推理与业务指标联动' },
                        { title: '企业级安全', desc: '零信任、加密传输与细粒度权限控制' },
                        { title: '低延时通信', desc: '优化网络链路与传输协议，保障实时性' },
                        { title: '可视化数据', desc: '清晰展示数据，让信息一目了然' },
                        { title: '开放 API', desc: '标准 REST 接口，便于集成与扩展' }
                    ].map((f, i) => (
                        <div key={i} className="p-5 bg-slate-800/40 rounded-xl border border-slate-700/30">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 rounded-md bg-sky-600/10 flex items-center justify-center"> <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M3 12h18" stroke="#7dd3fc" strokeWidth="1.6" strokeLinecap="round" /></svg></div>
                                <div>
                                    <div className="font-semibold">{f.title}</div>
                                    <div className="text-sm text-sky-300/60">{f.desc}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </section>

                {/* CTA */}
                <section className="mt-12 rounded-2xl bg-gradient-to-r from-slate-800/40 to-black/30 border border-slate-700/30 p-6 flex items-center justify-between">
                    <div>
                        <div className="text-lg font-semibold">准备好把业务带入智能时代了吗？</div>
                    </div>
                    <div className="flex gap-3">
                        <button className="px-5 py-3 rounded-lg bg-white/5 border border-sky-500" onClick={contactUs}>立即开始</button>
                    </div>
                </section>
            </div>
            <style>{` 
        @keyframes gradientShift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .animate-gradient-text {
          background-size: 200% 200%;
          animation: gradientShift 5s ease infinite;
        }
      `}</style>
        </div>
    );
}

export default Home;
